var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9949 2.29997C35.4089 2.29997 44.6949 11.5859 44.6949 23C44.6949 34.414 35.4089 43.7 23.9949 43.7C12.5809 43.7 3.29492 34.414 3.29492 23C3.29492 11.5859 12.5809 2.29997 23.9949 2.29997M23.9951 0C11.2926 0 0.995117 10.2974 0.995117 23C0.995117 35.7026 11.2926 46 23.9951 46C36.6977 46 46.9951 35.7026 46.9951 23C46.9951 10.2974 36.6978 0 23.9951 0ZM20.3023 31.115L35.1332 16.5244C35.5869 16.0797 35.5914 15.3519 35.1467 14.8982C34.6997 14.4423 33.9742 14.44 33.5205 14.8848L19.4959 28.6825L13.2832 22.5709C12.8295 22.1261 12.1018 22.1284 11.6571 22.5843C11.2123 23.0381 11.2168 23.7658 11.6705 24.2105L18.6896 31.115C18.9142 31.3351 19.2039 31.4452 19.4959 31.4452C19.7879 31.4452 20.0778 31.3351 20.3023 31.115L20.3023 31.115Z",
    fill: "#007D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckOutlined);
export default __webpack_public_path__ + "static/media/green_check_outlined.3d22b9a3ffc02f7f6d250eb641888072.svg";
export { ForwardRef as ReactComponent };